export default __webpack_public_path__ + "static/media/courseOfflineIcon.1387d55f.svg";